import React from 'react';
import { CheckCircle } from 'lucide-react';

const CompletionPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-orange-50 to-white flex items-center justify-center p-6">
      <div className="max-w-2xl w-full text-center">
        {/* Success Icon */}
        <div className="mb-8">
          <CheckCircle className="w-24 h-24 text-green-500 mx-auto" strokeWidth={1.5} />
        </div>
        
        {/* Main Heading */}
        <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
          Agreement Completed Successfully!
        </h1>
        
        {/* Subheading */}
        <p className="text-xl sm:text-2xl text-gray-600 mb-8">
          A PDF copy of your Tax Services Agreement has been sent to your email address.
        </p>
        
        {/* Divider */}
        <div className="w-24 h-1 bg-orange-500 mx-auto mb-8"></div>
        
        {/* Close Message */}
        <p className="text-lg text-gray-500">
          You may now safely close this browser tab.
        </p>
        
        {/* TCA Logo */}
        <div className="mt-12">
          <img 
            src="/images/TCA_Logo.png" 
            alt="TCA Auditors" 
            className="h-16 mx-auto opacity-60"
          />
        </div>
      </div>
    </div>
  );
};

export default CompletionPage;
